import {
    Component,
    InputSignal,
    OutputEmitterRef,
    inject,
    input,
    output, ChangeDetectionStrategy
} from "@angular/core";
import {AnalyticsService} from '../../logging/analytics.service';
import {NavigationService} from "../../navigation/navigation.service";
import {TranslateModule} from '@ngx-translate/core';
import {LinkComponent} from '../../buttons/link/link.component';
import {HtmlPipe} from '../../utils/html.pipe';

@Component({
    selector: "woa-legal-panel",
    templateUrl: "./legal-panel.component.html",
    styleUrl: "./legal-panel.component.scss",
    imports: [
        HtmlPipe,
        LinkComponent,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegalPanelComponent {
    private analyticsService: AnalyticsService = inject(AnalyticsService);
    private navigationService: NavigationService = inject(NavigationService);

    public readonly messageSet: InputSignal<string> = input.required<string>();

    public readonly messageParams: InputSignal<Record<string, string | number>> = input<Record<string, string | number>>({});
    public readonly showFeedback: InputSignal<boolean> = input<boolean>(false);

    public onLinkOpened: OutputEmitterRef<string> = output<string>();

    async feedback(): Promise<void> {
        this.onLinkOpened.emit("feedback");
        void this.analyticsService.trackNavOption("feedback");
        return this.navigationService.createPage("woa-feedback-page");
    }

    async showAdminDetails(display: "terms" | "privacy"): Promise<void> {
        this.onLinkOpened.emit(display);
        void this.analyticsService.trackNavOption(display);
        return this.navigationService.createPage("woa-legal-page", {display: display});
    }
}
